import { graphql, useStaticQuery } from 'gatsby';

import type { Lucid } from '../types/types';

const useSiteMetadata = () => {
  const { site } = useStaticQuery<Lucid.Query.Hooks.UseSiteMetadata>(graphql`
    query useSiteMetadataQuery {
      site {
        siteMetadata {
          blogPostsPerPage
          cmsUrl
          grecaptchaSiteKey
          metaImage
          product
          siteDomain
          siteName
          siteUrl
          title
        }
      }
    }
  `);

  return site.siteMetadata;
};

export default useSiteMetadata;
